'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FavoritesIndicator = require('./FavoritesIndicator');

var _FavoritesIndicator2 = _interopRequireDefault(_FavoritesIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FavoritesIndicator2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/FavoritesIndicator/index.js
// module id = 579
// module chunks = 11